import React from "react";
import PropTypes from "prop-types";
import BasicDataChangeFormContent from "../components/BasicDataChangeFormContent";
import { FormMenu } from "../../../components/Buttons";

import { connect } from "react-redux";
import { updateBasicData } from "../../../redux/actions/auth";
import { loadCurrentWorker } from "../../Worker/actions";

const mapStateToProps = (state) => {
  return {
    user: state.worker.currentWorker,
  };
};
const mapDispatchToProps = (dispatch) => ({
  updateData: (...args) => dispatch(updateBasicData(...args)),
  loadProfile: (...args) => dispatch(loadCurrentWorker(...args)),
});

const BasicDataChangeForm = (props) => {
  const { className, user, updateData, loadProfile, onClose } = props;
  const formRef = React.useRef(null);

  const onSave = () => {
    const model = formRef.current.getModel();
    if (!model) return;
    console.log(">> updating basic data", model);
    updateData(model, () => {
      onClose();
      loadProfile();
    });
  };
  const onCancel = () => {
    onClose && onClose();
  };

  return (
    <div className={`${className}`}>
      <BasicDataChangeFormContent ref={formRef} model={user} />
      <FormMenu
        className="margin-lg-top w3-border-top pad-big w3-light-grey"
        style={{
          marginLeft: "-1em",
          marginRight: "-1em",
          marginBottom: "-1em",
        }}
        onSave={onSave}
        onCancel={onCancel}
        saveBtnName="updateBasicDataBtn"
      />
    </div>
  );
};

BasicDataChangeForm.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape({}),
  updateData: PropTypes.func.isRequired,
  loadProfile: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
BasicDataChangeForm.defaultProps = {
  className: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasicDataChangeForm);
